import { Box, Typography } from '@mui/material';
import { useStyles } from './styles';
import { IHelperBoxProps } from './interfaces';

const HelperBox = ({ title, text }: IHelperBoxProps) => {
  const classes = useStyles();
  return (
    <Box sx={classes.helper}>
      <Typography sx={classes.helperTitle}>{title}</Typography>
      <Typography sx={classes.helperText}>{text}</Typography>
    </Box>
  );
};

export default HelperBox;
